import React, { useState } from "react";
import { ResearchProject } from "../types";

interface ResearchProjectCardProps {
  project: ResearchProject;
}

const ResearchProjectCard: React.FC<ResearchProjectCardProps> = ({
  project,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  // Function to bold Alex Mari (AUBH) in team text
  const formatTeamText = (text: string) => {
    return text.replace(
      /Alex Mari \(AUBH\)/g,
      "<strong>Alex Mari (AUBH)</strong>"
    );
  };

  return (
    <div className="research-project glass card">
      <div className="project-title">
        <strong>{project.id}. Title: </strong>
        {project.title}
      </div>
      <div className="project-team">
        <strong>Team:</strong>{" "}
        <span
          dangerouslySetInnerHTML={{ __html: formatTeamText(project.team) }}
        />
      </div>
      <div className="project-abstract">
        <strong>Abstract:</strong> {project.abstract}
        {project.fullAbstract && (
          <>
            {" "}
            <span className="read-more" onClick={toggleExpand}>
              {isExpanded ? "(READ LESS)" : "(READ MORE)"}
            </span>
            {isExpanded && (
              <span
                className="expandable-content"
                style={{ display: "inline" }}
              >
                {" " + project.fullAbstract.substring(project.abstract.length)}
                {/* Include preliminary results link in expanded content */}
                {project.link && (
                  <>
                    <br />
                    <br />
                    <a
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="navigation-arrow"
                    >
                      {">> Preliminary results (Hume AI)"}
                    </a>
                  </>
                )}
              </span>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ResearchProjectCard;
